import React from 'react'
import { Link, NavLink, Outlet } from 'react-router-dom'
import type { TenantThemeConfig } from '../../types/theme'
import './affiliateLayout.css'

interface AssetConfig {
  CDN_BASE_URL: string
  CSS_PATH: string
  IMG_PATH: string
  FONTS_PATH: string
}

export interface AffiliateOutletContext {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

interface ModernAffiliateLayoutProps {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

const TABS = [
  { to: 'overview', label: 'ภาพรวม', icon: 'fas fa-sitemap' },
  { to: 'member', label: 'สมาชิก', icon: 'fas fa-users' },
  { to: 'income', label: 'รายได้', icon: 'fas fa-chart-bar' },
  { to: 'topten', label: 'Top 10', icon: 'fas fa-trophy' },
]

/** Layout หน้าแนะนำเพื่อน (affiliate): หัวข้อ + แท็บ 4 อัน + Outlet */
const ModernAffiliateLayout: React.FC<ModernAffiliateLayoutProps> = ({ themeConfig, assetConfig }) => {
  const context: AffiliateOutletContext = { themeConfig, assetConfig }

  return (
    <div className="content htd-aff">
      <div className="htd-aff__glow" aria-hidden />
      <div className="htd-aff__inner">
        <header className="htd-aff__hero htd-aff-anim htd-aff-anim--1">
          <Link to="/dashboard" className="htd-aff__back">
            กลับหน้าหลัก
          </Link>
          <div className="htd-aff__badge" aria-hidden>
            <i className="fas fa-user-friends" />
          </div>
          <div>
            <p className="htd-aff__eyebrow">Affiliate Hub</p>
            <h1 className="htd-aff__title">ระบบแนะนำ</h1>
            <p className="htd-aff__desc">แชร์ลิงก์ รับคอมมิชชั่น และติดตามสมาชิกในเครือข่าย</p>
          </div>
        </header>

        <nav className="htd-aff__tabs htd-aff-anim htd-aff-anim--2" aria-label="แท็บแนะนำเพื่อน">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.to === 'overview'}
              className={({ isActive }) => `htd-aff__tab${isActive ? ' is-active' : ''}`}
            >
              <span className="htd-aff__tab-icon" aria-hidden>
                <i className={tab.icon} />
              </span>
              <span className="htd-aff__tab-label">{tab.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="htd-aff__outlet htd-aff-anim htd-aff-anim--3">
          <Outlet context={context} />
        </div>
      </div>
    </div>
  )
}

export default ModernAffiliateLayout
